export const STRIPE_PRICING_TABLE_ID =
	process.env.STRIPE_PRICING_TABLE_ID || 'prctbl_1Q3kmqRxb9JcvOQlIJLzjCu7'
export const STRIPE_PUBLISHABLE_KEY =
	process.env.STRIPE_PUBLISHABLE_KEY ||
	'pk_live_51PT3cvRxb9JcvOQlJ7jA35VD87JyZqyXXLRQwIgEo1t3CHa8txJ1AHEc9qofTUhcQvqcaQ6IsSrhbz4r2hR7kvCk0087vF8GnZ'
export const STRIPE_ACCOUNT_MANAGEMENT_URL =
	'https://billing.stripe.com/p/login/fZe6qda2laSIfde9AA'
